export default __webpack_public_path__ + "static/Code-img-32950c3cbac0e5fe39132b43f4ca9c2b.png";